/**
 * المرحلة 1.35 — the medical centre's four policies as the screens read them:
 * the same cleaning as Backend/lib/centerPolicy.js, applied to what
 * /api/auth/capabilities sends as `locale.center`. A session without it (a
 * patient, an independent doctor, the capabilities still on their way) reads
 * the defaults, which are today's behaviour: no price list, the classic
 * reception, no child file, no stay booklet.
 *
 * A rendering aid, not the boundary: every route checks the policy again.
 * Tests/suites/frontend/p135-center.test.mjs keeps the two equal.
 */

const pick = (value, allowed, dflt) => (allowed.includes(String(value)) ? String(value) : dflt);

function priceList(p = {}) {
  return {
    enabled: pick(p.enabled, ['no', 'yes'], 'no'),
    editors: pick(p.editors, ['managers', 'managers_and_accounts'], 'managers_and_accounts'),
  };
}

function quickReception(p = {}) {
  return {
    layout: pick(p.layout, ['classic', 'quick', 'both'], 'classic'),
    nameParts: Number(pick(p.nameParts, ['4', '3', '2'], '4')),
    minorDefault: pick(p.minorDefault, ['no', 'yes'], 'no'),
    softCopy: pick(p.softCopy, ['link', 'off'], 'link'),
    linkDays: Number(pick(p.linkDays, ['7', '30', '90'], '30')),
    discounts: pick(p.discounts, ['named', 'off'], 'named'),
    refunds: pick(p.refunds, ['desk', 'accounts', 'off'], 'desk'),
  };
}

function childFile(p = {}) {
  return {
    enabled: pick(p.enabled, ['no', 'yes'], 'no'),
    showTo: pick(p.showTo, ['doctor_and_desk', 'doctor_only'], 'doctor_and_desk'),
  };
}

function stayBooklet(p = {}) {
  return {
    enabled: pick(p.enabled, ['no', 'yes'], 'no'),
    review: pick(p.review, ['accounts', 'none'], 'accounts'),
    discharge: pick(p.discharge, ['accounts_clearance', 'free'], 'accounts_clearance'),
  };
}

export const READERS = Object.freeze({ priceList, quickReception, childFile, stayBooklet });

/** All four, cleaned, from `usePermissions().locale` (or null). */
export function centerPolicy(locale) {
  const raw = (locale && locale.center) || {};
  return {
    priceList: priceList(raw.priceList || {}),
    quickReception: quickReception(raw.quickReception || {}),
    childFile: childFile(raw.childFile || {}),
    stayBooklet: stayBooklet(raw.stayBooklet || {}),
  };
}

/** Is one of the switchable ones on? (`priceList`, `childFile`, `stayBooklet`; the reception is on when it is not classic.) */
export function centerOpen(locale, id) {
  const policy = centerPolicy(locale);
  if (id === 'quickReception') return policy.quickReception.layout !== 'classic';
  return Boolean(policy[id]) && policy[id].enabled === 'yes';
}
